import { useState, useRef } from "react";

import { API_URL, isFieldError } from "../helpers";

import Input from "../components/Input";
import Checkbox from "../components/Checkbox";
import Msg from "../components/Msg";
import Submit from "../components/Submit";

const Form = ({ details }) => {
	const [names, setNames] = useState({});
	const [errors, setErrors] = useState([]);
	const [msg, setMsg] = useState({});

	const formElement = useRef(null);

	const handleUpdate = (name, value) => {
		setNames((names) => ({ ...names, [name]: value ? value : "" }));
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setErrors([]);
		setMsg({
			type: "working",
			text: "",
		});

		const url = new URL(`${API_URL}/tickets`);
		let data = new FormData();
		Object.entries(names).forEach(([key, value]) => {
			if (key === "enter") {
				data.append(key, value ? "1" : "0");
			} else {
				data.append(key, value);
			}
		});

		try {
			const response = await fetch(url, {
				method: "POST",
				body: data,
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				formElement.current.email.value = "";
				//formElement.current.enter.checked = false;

				if (names.enter) {
					formElement.current.fname.value = "";
					formElement.current.lname.value = "";
					formElement.current.phone.value = "";
					formElement.current.zip.value = "";
				}
				setNames({});

				setMsg({
					type: "success",
					text: json.text,
				});
			} else {
				setErrors(json.fields);
				setMsg({
					type: "error",
					text: json.text,
				});
			}
		} catch (error) {
			setMsg({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	return (
		<form
			ref={formElement}
			method="post"
			action="/"
			onSubmit={(e) => handleSubmit(e)}
			className="well"
			style={{ marginBottom: "30px" }}
		>
			<p style={{ marginTop: "0" }}>
				Register your email address below to be notified when tickets go on
				sale.
			</p>

			<div className="form-group">
				<Input
					name="email"
					label="Email"
					reqd={true}
					value={""}
					update={handleUpdate}
					errors={errors}
				/>

				<div className="empty" />
			</div>

			{/*<p style={{ marginBottom: "0" }}>
				<strong style={{ fontSize: "1.15rem" }}>ENTER TO WIN</strong>
			</p>

			<div
				className="form-group checkbox"
				style={{
					marginLeft: "0",
					marginTop: "5px",
					marginBottom: "0",
				}}
			>
				<Checkbox
					name="enter"
					label="Check for a chance to WIN an “inside the ropes” experience as an
					Honorary Observer. Ends January 22, 2024."
					checked={names.enter}
					click={handleUpdate}
				/>
			</div>*/}

			{names.enter && (
				<p style={{ marginTop: "10px" }}>
					<a
						href="https://vto.qnmcdn.com/assets/pdf/honorary-observer-prize-details-rules.pdf"
						target="_blank"
						rel="noreferrer"
					>
						Honorary Observer Prize Details & Rules
					</a>
				</p>
			)}

			{names.enter && (
				<div className="form-group">
					<Input
						name="fname"
						label="First Name"
						reqd={true}
						value={""}
						autocomplete="given-name"
						update={handleUpdate}
						errors={errors}
					/>
					<Input
						name="lname"
						label="Last Name"
						reqd={true}
						value={""}
						autocomplete="family-name"
						update={handleUpdate}
						errors={errors}
					/>
				</div>
			)}

			{names.enter && (
				<div className="form-group">
					<Input
						name="phone"
						label="Mobile / Cell Number"
						reqd={true}
						value={""}
						autocomplete="tel"
						update={handleUpdate}
						errors={errors}
					/>
					<Input
						name="zip"
						label="Zip Code"
						reqd={true}
						value={""}
						update={handleUpdate}
						errors={errors}
					/>
				</div>
			)}

			<div className="msg-submit">
				{msg.type && <Msg data={msg} />}

				<div className={msg.type === "working" ? "hidden" : "submit-container"}>
					<Submit
						submit={
							names.enter
								? "Register Notification & Enter to Win"
								: "Register Notification"
						}
					/>
				</div>
			</div>
		</form>
	);
};

export default Form;
